import React from "react";
import DataTable from 'react-data-table-component';

export default function CommanBarTable_Kratos(props) {
  let data = props.data
  let tabDataKey = props.tabDataKey

  const columns = [
    {
      name: 'Vin Number',
      selector: (row) => row.key.vehicleId,
      sortable: true,
      width: '30%',
    },
    {
      name: 'Value',
      selector: (row) => row[tabDataKey].value,
      sortable: true,
      width: '20%',
      cell: (row) => (
        <span>{row[tabDataKey].value.toFixed(2)}</span>
      ),
    },
    {
      name: 'Reg No',
      selector: (row) => row.key.vehicle_registration_number,
      sortable: true,
      width: '25%',
    },
    // {
    //   name: 'Depot',
    //   selector: (row) => row.key.Depot_Name,
    //   sortable: true,
    //   width: '20%',
    // },
    {
      name: 'City',
      selector: (row) => row.key.DLR_ORG_CITY,
      sortable: true,
      width: '25%',
    }
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#83A4CF',
        color: '#fff',
        fontWeight: 'bold'
      },
    },
  };

  return (
    <>
      <DataTable
        columns={columns}
        data={data}
        customStyles={customStyles}
        fixedHeader={true}
        fixedHeaderScrollHeight='250px'
      />
    </>
  );
}